import 'ui-core/plugins/drawer/js/drawer';

UX.menu.on.showNestedExtra = function () {
    $('.top-nav__links, .top-nav__institution').addClass('prev-items');
};

UX.menu.on.hideNestedExtra = function () {
    $('.top-nav__links, .top-nav__institution').removeClass('prev-items');
};

UX.menu.on.listPosition.start = function () {};

UX.menu.on.listPosition.handleHeightSet = function () {};

UX.menu.on.listPosition.reset = function () {};
